export const getMembersPageListPath = (userId: string): string => {
    return `$..members.users.${userId}`
}

export const updateStaticMembersPath = (): string =>{
    return '$.persistent.static.members'
}